// extracted by mini-css-extract-plugin
export default {"root":"tD31a6mjzW","scrollableContainer":"YttSUVsWCC","timeSpan":"przJh9ryiz","itemError":"DROaThzu1Z","errorMessage":"cvuUcyMqte","onlineMeetingButtonWrapper":"KFTJwMV2P5"};